<div *ngIf="isRequesting">
  Loading...
</div>
<div class="input-group" *ngIf="!isRequesting">

  

  <select class="form-control" name="value" [(ngModel)]="value" (change)="onChange($event.target.value)" >

    <option *ngFor="let R of CurrentCustomCodeValuesController" [value]="R.Code"
            [selected]="R.DisplayName ===  SelectedValue ">
      {{R.DisplayName}}
    </option>
   
  </select>
    
</div>
